module.exports = __webpack_public_path__ + "static/media/retail.b4302b59.wav";